import React, { FC, useMemo } from "react";
import { Button, Tooltip, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

type AyushmanInvestigationUploadProps = {
  investigationOptions: any[];
  uploadedInvestigationFileList: any[];
  isDisabled?: boolean;
  onUploadFile: (investigationOption: any, file: File) => void;
};

const matchUploadedDocs = (option: any, uploads: any[] = []) =>
  (uploads || []).filter((u) => {
    const optionKeys = [option?.labelId, option?.id, option?.documentUniqueCode]
      .filter((k) => k !== undefined && k !== null && String(k) !== "")
      .map(String);
    const docKeys = [u?.documentType, u?.documentUniqueCode]
      .filter((k) => k !== undefined && k !== null && String(k) !== "")
      .map(String);
    if (optionKeys.some((k) => docKeys.includes(k))) return true;

    const optionLabels = [option?.label, option?.name, option?.documentMasterName]
      .filter(Boolean)
      .map((s) => String(s).toLowerCase().trim());
    const uploadedLabel = String(
      u?.documentLabelType || u?.documentMasterName || "",
    )
      .toLowerCase()
      .trim();
    return Boolean(uploadedLabel) && optionLabels.includes(uploadedLabel);
  });

const AyushmanInvestigationUpload: FC<AyushmanInvestigationUploadProps> = ({
  investigationOptions,
  uploadedInvestigationFileList,
  isDisabled,
  onUploadFile,
}) => {
  const uploadOptions = useMemo(() => {
    return (investigationOptions || []).filter(
      (option) =>
        matchUploadedDocs(option, uploadedInvestigationFileList).length === 0,
    );
  }, [investigationOptions, uploadedInvestigationFileList]);

  if (!(investigationOptions || []).length) return null;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "16px 0",
        }}
      >
        <div
          style={{
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          INVESTIGATIONS
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          marginBottom: 16,
        }}
      >
        {uploadOptions.map((option) => {
          const label = option?.label || option?.name || "-";
          return (
            <div
              key={String(option?.labelId ?? option?.id ?? label)}
              style={{
                border: "1px solid #eee",
                padding: 10,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Upload
                beforeUpload={() => false}
                showUploadList={false}
                maxCount={1}
                disabled={isDisabled}
                onChange={(info) => {
                  const file = (info?.file as any)?.originFileObj || info?.file;
                  if (!file) return;
                  onUploadFile(option, file as File);
                }}
              >
                <Button
                  icon={<UploadOutlined />}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 0,
                    border: "none",
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                  }}
                  disabled={isDisabled}
                />
              </Upload>
              <Button
                style={{
                  borderRadius: 0,
                  border: "none",
                  paddingLeft: 4,
                  borderTopRightRadius: "6px",
                  borderBottomRightRadius: "6px",
                }}
                iconPosition="end"
              >
                <Tooltip title={label}>
                  <span>
                    {label?.length > 25 ? `${label.substring(0, 25)}...` : label}
                  </span>
                </Tooltip>
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AyushmanInvestigationUpload;
